import React from 'react';
import { Award, Clock, Shield, ThumbsUp } from 'lucide-react';

const AboutSection = () => {
  const values = [
    {
      icon: Award,
      title: 'Professional Service',
      description: 'Experienced and reliable lawn care for your property'
    },
    {
      icon: Clock,
      title: 'Always On Time',
      description: 'Punctual service with flexible scheduling options'
    },
    {
      icon: Shield,
      title: 'Fully Insured',
      description: 'Complete peace of mind with full insurance coverage'
    },
    {
      icon: ThumbsUp,
      title: 'Quality Guaranteed',
      description: 'We take pride in delivering excellent results every time'
    }
  ];

  return (
    <section id="about" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Column - Text */}
          <div>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
              About <span className="text-green-600">Mini Mike Mowing</span>
            </h2>
            <p className="text-lg text-gray-600 mb-6">
              Mini Mike Mowing is your trusted local lawn mowing and garden maintenance specialist serving Melbourne's southeast. We're committed to providing professional, affordable, and reliable lawn care services to residential properties.
            </p>
            <p className="text-lg text-gray-600 mb-6">
              With a focus on quality workmanship and customer satisfaction, we take pride in keeping your outdoor spaces looking their absolute best. Whether you need regular lawn mowing or complete garden maintenance, we're here to help.
            </p>
            <p className="text-lg text-gray-600 mb-8">
              As a local business, we understand the needs of our community and are dedicated to delivering exceptional service at competitive rates. Get in touch today for a fast quote!
            </p>

            {/* Stats */}
            <div className="grid grid-cols-2 gap-6">
              <div className="bg-green-50 rounded-xl p-6">
                <div className="text-3xl font-bold text-green-600 mb-1">100+</div>
                <div className="text-sm text-gray-600">Happy Customers</div>
              </div>
              <div className="bg-green-50 rounded-xl p-6">
                <div className="text-3xl font-bold text-green-600 mb-1">5★</div>
                <div className="text-sm text-gray-600">Service Quality</div>
              </div>
            </div>
          </div>

          {/* Right Column - Values */}
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {values.map((value, index) => {
                const Icon = value.icon;
                return (
                  <div
                    key={index}
                    className="bg-gray-50 rounded-xl p-6 hover:bg-green-50 transition-all duration-300 border-2 border-transparent hover:border-green-200"
                  >
                    <div className="w-12 h-12 bg-white rounded-lg flex items-center justify-center mb-4 shadow-sm">
                      <Icon className="h-6 w-6 text-green-600" />
                    </div>
                    <h3 className="text-lg font-bold text-gray-900 mb-2">{value.title}</h3>
                    <p className="text-sm text-gray-600">{value.description}</p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
